import { toString } from '../../../shared/helpers';

const fixDataTypes = sheetAsJson =>
  sheetAsJson.map(taxRate => ({
    ...taxRate,
    countryCode: toString(taxRate.countryCode),
    countryTaxType: toString(taxRate.countryTaxType),
    description: toString(taxRate.description),
    enabledFlag: toString(taxRate.enabledFlag),
    taxRate: taxRate.taxRate || taxRate.taxRate === 0 ? Number(taxRate.taxRate).toFixed(6) : undefined, // eslint-disable-line no-undefined
    defTaxRate: taxRate.defTaxRate || taxRate.defTaxRate === 0 ? Number(taxRate.defTaxRate).toFixed(6) : undefined, // eslint-disable-line no-undefined
    plAccount: toString(taxRate.plAccount),
    bsAccount: toString(taxRate.bsAccount),
    defPlAccount: toString(taxRate.defPlAccount),
    defBsAccount: toString(taxRate.defBsAccount),
  }));

export default fixDataTypes;
